<div class="container cpal">
    <div class="row mb-5">
    <h2>Solicitud de Crédito</h2>
</div>
    <form [formGroup]="solicitudForm" (ngSubmit)="onSubmit()" class="row">
        <mat-form-field appearance="outline" class="col-md-4">
            <mat-label>Monto</mat-label>
            <input matInput currencyMask type="text" placeholder="$" formControlName="monto">
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-md-4">
            <mat-label>Duración (meses)</mat-label>
            <input matInput type="text" placeholder="Duración (meses)" formControlName="duracion" pattern="[0-9]*" inputmode="numeric">
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-md-4">
            <mat-label>Fecha Solicitud</mat-label>
            <input matInput [matDatepicker]="picker" placeholder="Fecha de Solicitud" formControlName="fechaSolicitud">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <div class="mt-4">
            <button class="fr" mat-raised-button color="primary" type="submit" [disabled]="solicitudForm.invalid">Enviar Solicitud 	<mat-icon>send</mat-icon></button>
        </div>
        
    </form>
</div>
